// extracted by mini-css-extract-plugin
export default {"filters_container":"reportSkeleton_filters_container__TfH0d","mock_filter":"reportSkeleton_mock_filter__1xu+D"};